import { h100vh } from "../tools";

const styles = {
  boxLoader: {
    ...h100vh,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
};

export { styles };
